/**
 * Created by nijin on 20/12/16.
 */
import {Component, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {ThingsService} from '../things.service';
import {ThingModel} from '../model/Ithing.model';
import {Router, ActivatedRoute} from '@angular/router';

import {NotificationType} from '../../core/notify/index';

import {NotificationBarService} from '../../core/notify/notification.service';
import {GlobalService} from '../../global/global.service';
@Component({
  selector: 'nuc-things-list',
  templateUrl: './things-list.component.html',
  styleUrls: ['./things-list.component.scss']
})
export class ThingsListComponent implements OnInit, OnDestroy {
  thingsList: Array<ThingModel> = [];
  selectedThings: Array<ThingModel> = [];
  isLoading: boolean;
  isSearch: boolean;
  searchKey: string;
  // pagination details
  currentPage = 1;
  pageSize  = 10;
  totalPage;
  maxSize = 3;
  sub;

  @ViewChild('popup') clonePopup;
  @ViewChild('confirm') confirm;
  @ViewChild('search') search: ElementRef;

  constructor(
    private thingsService: ThingsService,
    private router: Router,
    private notifier: NotificationBarService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      const term = params['search-key'];


      this.searchKey = term ? term : '';
      this.isSearch = !!term;

      const page = params['page'] ?  params['page'] : 1 ;
      this.currentPage = page;
      if (term || page) {
        this.search.nativeElement.value = '';
        this.getAllThings({'search-key': term, 'page': page});
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getAllThings(param?) {
    this.isLoading = true;
    if (!param) {
      param = {};
    }
    param['page-size'] = this.pageSize;
    this.thingsService.getAllThings(param)
      .subscribe((response) => {
        this.thingsList = response.items;
        this.isLoading = false;
        this.totalPage = response.count;
      } ,
        () => {this.isLoading = false; });
  }

  navigate() {
    this.router.navigate(['/things/device/new']);
  }



  navigateToDetails(token) {
    this.router.navigate(['/things', token]).then();
  }

  selectThing(thing, isSelected) {
    if (isSelected && this.selectedThings.indexOf(thing) > -1) {
      this.selectedThings.splice(this.selectedThings.indexOf(thing), 1);
      return;
    } else {
      this.selectedThings = [];
      this.selectedThings.push(thing);
    }



    // future implementation of multiple selection
    /* isSelected ? this.selectedThings.push(thing) :
      this.selectedThings.splice(this.selectedThings.indexOf(thing), 1);

      */
  }

  selectAllThings(isSelectAll) {
    isSelectAll ? this.selectedThings = this.selectedThings = this.thingsList.slice()
      :  this.selectedThings = [];

  }
  open() {
    this.clonePopup.open();
  }

  cloneThingSuccess(response) {
    this.notifier.create({message: response.status.message, type: NotificationType.Success});
    this.isLoading = false;
    this.getAllThings({page: this.currentPage});
    this.selectedThings = [];
  }

  pageChange(pageData) {
    this.selectedThings = [];
    this.currentPage = pageData.page;
    const param = {};
    param['page'] = pageData.page;
    if(this.searchKey) {
      param['searchKey'] = this.searchKey;
    }
    this.router.navigate(['/things', param]);
    //this.getAllThings(pageData);
  }

  searchByName(key) {
    this.isSearch = true;
    this.searchKey = key;
    this.router.navigate(['/things', {'search-key':key, 'page': 1}]);
  }

  openDeleteThing() {
    this.confirm.open();
  }

  confirmDelete(isConfirmation) {
    if (!isConfirmation) {
      this.confirm.close();
      return;
    }

    this.deleteThing();
  }

  private deleteThing() {
    this.isLoading  = true;
    this.thingsService.deleteThingMiddleware(this.selectedThings[0])
      .subscribe((response) => {
        this.confirm.close();
        this.isLoading = false;
        let idx = this.thingsList.indexOf(this.selectedThings[0]);
        this.thingsList.splice(idx, 1);
        this.notifier.create({message: response.status.message, type: NotificationType.Success});
        this.currentPage = this.thingsList.length ? this.currentPage : 1;
        this.getAllThings({page: this.currentPage});
        this.selectedThings = [];
      },
        () => {
          this.isLoading = false;
          this.confirm.close();
        });
  }




}



// WEBPACK FOOTER //
// ./src/app/things/things-list/things-list.component.ts